<template lang="pug">
el-row
  el-col(:sm="8")
    el-table(border, style="width:100%", :data="totalsData.official", :row-style="rowStyle")
      el-table-column(prop="_1", label="Фактури", :formatter="priceFormatter")
      el-table-column(prop="_3", label="Кредитни", :formatter="priceFormatter")
      el-table-column(prop="_13", label="Общо до тук", :formatter="priceFormatter")
  el-col(:sm="5")
    h1
      small Разлика:
      div {{ total1_13 - total2_13 | formatPrice }} лв.
  el-col(:sm="6")
    el-table(border, style="width:100%", :data="totalsData.unofficial", :row-style="rowStyle")
      el-table-column(prop="_2", label="Без документ", :formatter="priceFormatter")
      el-table-column(prop="_123", label="Общо до тук", :formatter="priceFormatter")


  el-col(:sm="5")
    h1
      small Разлика:
      div {{ balance | formatPrice }} лв.



      //- el-table-column(v-for="k in dataKeys", :prop="k", :label="dataInfo[k].name", :formatter="priceFormatter")
      //-   template(scope="scope")
      //-     span(:style="{color: dataInfo[k].color}") {{ priceFormatter(scope.row, scope.column) }}
      //- el-table-column(label="Баланс", width="200")
      //-   template(scope="scope")
      //-     span() {{ totalFormatter(scope.row) }}
</template>

<script>
import * as dateUtil from '../lib/dateUtil'

export default {
  props: {
    rawData: {default: false},
    tickFormat: {default: 'YYYY-MM-DD'},
    dataInfo: {},
    dataKeys: {}
  },
  computed: {
    total1_1 () { return this.rawData['1_1'].reduce((sum, r) => sum + r, 0) },
    total1_2 () { return this.rawData['1_2'].reduce((sum, r) => sum + r, 0) },
    total1_3 () { return this.rawData['1_3'].reduce((sum, r) => sum + r, 0) },
    total2_1 () { return this.rawData['2_1'].reduce((sum, r) => sum + r, 0) },
    total2_2 () { return this.rawData['2_2'].reduce((sum, r) => sum + r, 0) },
    total2_3 () { return this.rawData['2_3'].reduce((sum, r) => sum + r, 0) },

    total1_13 () { return this.total1_1 + this.total1_3},
    total1_123 () { return this.total1_1 + this.total1_2 + this.total1_3},

    total2_13 () { return this.total2_1 + this.total2_3},
    total2_123 () { return this.total2_1 + this.total2_2 + this.total2_3},

    balance () { return this.total1_123 - this.total2_123 },

    totalsData () {
      return {
        official: [
          {'_1': this.total1_1, '_3': this.total1_3, '_13': this.total1_13},
          {'_1': this.total2_1, '_3': this.total2_3, '_13': this.total2_13}
        ],
        unofficial: [
          {'_2': this.total1_2, '_123': this.total1_123},
          {'_2': this.total2_2, '_123': this.total2_123},
        ]
      }
    }
  },
  methods: {
    rowStyle ({row, rowIndex}) {
      return  'color: ' + this.dataInfo[rowIndex == 0 ? '1_3' : '2_3'].color
    },
    priceFormatter (row, column) {
      return this.common.formatPrice(Math.abs(row[column.property]), true)
    },
  }
}
</script>